<template>
  <Loader
    :value="promises.fetchOne"
    theme="default"
    class="project-fallback"
    :style="{ backgroundImage: `url(${cover})` }"
  >
    <div class="project-fallback__content">
      <img v-if="logo" :src="logo" :alt="item.name" width="120" />
      <h1 v-else>{{ item.name }}</h1>
      <div class="project-fallback__message">{{ content }}</div>
    </div>
  </Loader>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import getCoverThumbnail from '@/utils/getCoverThumbnail'

export default {
  props: {
    id: String,
  },
  watch: {
    id: {
      handler: 'fetch',
      immediate: true,
    },
  },
  computed: {
    ...mapState('Project', ['promises', 'item']),
    logo() {
      return this.$path('item.media.logo.url') || this.$path('item.media.logoInverted.url')
    },
    cover() {
      return getCoverThumbnail(this.$path('item.media.cover') || [])
    },
    state() {
      if (!this.$path('item.publishing.from') && !this.$path('item.publishing.to')) return 'undefined'
      if (moment(this.$path('item.publishing.from')).isAfter(moment())) return 'coming'
      if (moment(this.$path('item.publishing.to')).isBefore(moment())) return 'expired'
    },
    content() {
      switch (this.state) {
        case 'undefined':
          return this.$t('projectWillPublish')
        case 'coming':
          return this.$t('projectWillPublishAt', { date: moment(this.$path('item.publishing.from')).format('LL') })
        case 'expired':
          return this.$t('projectUnpublished')
      }
    },
  },
  methods: {
    ...mapActions('Project', {
      fetch(dispatch) {
        return dispatch('fetch', [{ id: this.id }, { query: 'ProjectFallback' }]).then(data => {
          if (data.isPublished) return (window.location.href = data.url)
          if (!data.id) return this.$router.push({ path: 'notfound' })
        })
      },
    }),
  },
  metaInfo() {
    return {
      title: this.$t('home'),
      titleTemplate: `%s | ${this.$path('item.name') || this.$t('loading', { resource: undefined }) + '...'}`,
    }
  },
}
</script>

<style lang="scss">
.project-fallback {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  &__content {
    position: absolute;
    top: 0;
    left: 0;
    padding: 2rem 3rem 2rem 2rem;
    background-color: rgba(white, 0.5);
    backdrop-filter: blur(8px);
    border-radius: 0 0 var(--border-radius) 0;
    box-shadow: 0 20px 15px -15px rgba(black, 0.2);
  }

  &__message {
    margin-top: 1rem;
    font-weight: bold;
  }
}
</style>
